import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Input,
  Label,
  Button
} from "reactstrap";
import { useSelector , useDispatch } from 'react-redux';
import FileManagerWithSidebar from './File_manager/FileManagerWithSidebar';
import { Get_Share_Point_Files, Save_Share_Point_Creds, Save_Share_Point_File_To_Knowledge } from '../../slices/thunks';
import Loader from '../../Components/Common/Loader';
import Import_Sharepoint from './Knowledge_Tab_content/Import_Sharepoint';


const SharePoint = () => {
  const {  Bot_ID , Sharepoint_Details } = useSelector((state) => state.BotDetails.Bot_Details);
  const { loading } = useSelector((state) => state.SharePoint);
   const [selected_files, setselected_files] = useState([])
  const [modal_standard, setmodal_standard] = useState(false);


  // const {Site_Url,Site_Name,Client_Id,Client_Secret,Tenant_Id} = Sharepoint_Details

  const dispatch = useDispatch()

  // const [share_point_creds, setshare_point_creds] = useState({
  //   bot_id: Bot_ID,
  //   client_id: '',
  //   client_secret: '',
  //   site_name: '',
  //   site_url: '',
  //   tenant_id: ''
  // });

  // useEffect(() => {
  //     setshare_point_creds({
  //   bot_id: Bot_ID,
  //   client_id: Client_Id,
  //   client_secret: Client_Secret,
  //   site_name: Site_Name,
  //   site_url: Site_Url,
  //   tenant_id: Tenant_Id
  // })
  // }, [Site_Url,Site_Name,Client_Id,Client_Secret,Tenant_Id])


  useEffect(() => {
   

      dispatch(Get_Share_Point_Files({bot_id:Bot_ID}))

  }, [])
  

  // useEffect(() => {
  //  setshare_point_creds(sharepoint_creds)
  // }, [sharepoint_creds])
  
  

  // const [errors, setErrors] = useState({});
  // const [isFormValid, setIsFormValid] = useState(false);

  // const on_change_client_id = (e) => {
  //   const client_id = e.target.value;
  //   setshare_point_creds((prev) => ({
  //     ...prev,
  //     client_id
  //   }));
  // };

  // const on_change_client_secret = (e) => {
  //   const client_secret = e.target.value;
  //   setshare_point_creds((prev) => ({
  //     ...prev,
  //     client_secret
  //   }));
  // };

  // const on_change_site_name = (e) => {
  //   const site_name = e.target.value;
  //   setshare_point_creds((prev) => ({
  //     ...prev,
  //     site_name
  //   }));
  // };

  // const on_change_site_url = (e) => {
  //   const site_url = e.target.value;
  //   setshare_point_creds((prev) => ({
  //     ...prev,
  //     site_url
  //   }));
  // };

  // const on_change_tenant_id = (e) => {
  //   const tenant_id = e.target.value;
  //   setshare_point_creds((prev) => ({
  //     ...prev,
  //     tenant_id
  //   }));
  // };

  // Validate the form
  // const validateForm = () => {
  //   let formErrors = {};
  //   if (!share_point_creds.site_url) formErrors.site_url = 'Site URL is required';
  //   if (!share_point_creds.site_name) formErrors.site_name = 'Site Name is required';
  //   if (!share_point_creds.client_id) formErrors.client_id = 'Client ID is required';
  //   if (!share_point_creds.client_secret) formErrors.client_secret = 'Client Secret is required';
  //   if (!share_point_creds.tenant_id) formErrors.tenant_id = 'Tenant ID is required';

  //   setErrors(formErrors);
  //   return Object.keys(formErrors).length === 0;
  // };

  // useEffect(() => {
  //   setIsFormValid(validateForm()); // Re-run validation only when form state changes
  // }, [share_point_creds]); // Run this effect when share_point_creds state changes




  // const handleFetchFiles = () => {
  //   if (isFormValid) {
  //     let temp = JSON.parse(JSON.stringify(share_point_creds))
  //     temp.bot_id = Bot_ID
      
  //     dispatch(Save_Share_Point_Creds(temp))
  //   }
  // };


    const Save_File_To_Knowledge = ()=>{
    // Prepare files path .
    const file_path = selected_files.map((ele)=> ele.path+":")
    // console.log(Bot_ID)
    // console.log(file_path.join(","));
    
    let formData = new FormData();
    formData.append("Bot_ID", Bot_ID);
    formData.append("API_TYPE", "Sharepoint");
    formData.append("sharepoint_file_paths", file_path.join(","));

    // console.log(formData)

    // Dispatch using FormData
    dispatch(Save_Share_Point_File_To_Knowledge(formData));
  }


  return (
    <>
      <Card>
        <CardHeader>
          <div className="cust_header">
            <span>
              <b>Share point</b>
            </span>   
            <Import_Sharepoint modal_standard={modal_standard} setmodal_standard={setmodal_standard} />         
          </div>
        </CardHeader>
        <CardBody style={{paddingTop:'0px'}}>          
          
          <div className="file_explorer">
           {loading ? <Loader/>: !modal_standard ? <FileManagerWithSidebar setselected_files={setselected_files} /> : " "}

           <div className='bottom_button'>
             <Button disabled={selected_files.length <= 0} onClick={Save_File_To_Knowledge}>Store to Knowledge</Button>
             
           </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default SharePoint;
